import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "nerosun_cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-4 inset-x-4 sm:left-auto sm:right-4 sm:max-w-md z-[60] border border-white/15 bg-black/95 backdrop-blur-xl p-5 animate-rise"
    >
      <div className="flex items-start gap-3">
        <Cookie className="w-5 h-5 text-signal mt-0.5 shrink-0" />
        <div>
          <p className="text-sm text-foreground/85 leading-relaxed">
            We use cookies to run the site and to serve advertising via Google and partners. See our{" "}
            <Link to="/privacy" className="text-signal hover:underline">Privacy Policy</Link>.
          </p>
          <div className="flex items-center gap-3 mt-4">
            <button
              data-testid="cookie-accept"
              onClick={accept}
              className="font-mono text-xs uppercase tracking-widest bg-signal text-white px-4 py-2 hover:bg-signal-hover transition-colors"
            >
              Accept
            </button>
            <Link
              to="/privacy"
              className="font-mono text-xs uppercase tracking-widest text-muted-foreground hover:text-signal"
            >
              Learn more
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
